export default "__VITE_ASSET__bd760c89__"